import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import { Box } from '@zillow/constellation';

var OverlappingStack = /*#__PURE__*/forwardRef(function OverlappingStack(props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
    ref: ref,
    sx: Object.assign({}, props.sx, {
      display: 'grid',
      '> *': {
        gridArea: '1 / 1'
      }
    })
  }));
});
var OverlappingStack$1 = OverlappingStack;

export { OverlappingStack$1 as default };
